import React from "react";
import { DisplayProductsType } from "../components/DisplayProductType";

export function Storage(): JSX.Element {
    return <div>{DisplayProductsType("Storage")}</div>;
}

export default Storage;
